/**
 * @prettier
 */
import { makeStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export function FormCheckbox({ name, label, helperText, defaultValue = false, disabled, onChange: onChangeProp, idx, classes: classesProp, tooltipText }: Props): React.ReactElement {
    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();
    const classes = useStyles();

    return (
        <div className={classes.inputContainer}>
            <div className={classes.checkboxContainer}>
                <FormControlLabel
                    label={label}
                    control={
                        <Controller
                            control={control}
                            name={name}
                            render={({ onChange, onBlur, value, name }) => (
                                <Checkbox
                                    onBlur={onBlur}
                                    onChange={e => {
                                        onChange(e.target.checked);
                                        onChangeProp && onChangeProp(idx);
                                    }}
                                    checked={value}
                                    name={name}
                                    color='primary'
                                    disabled={isSubmitting || disabled}
                                    classes={{ root: classesProp?.input }}
                                    aria-label={label ? undefined : name}
                                />
                            )}
                            defaultValue={defaultValue}
                        />
                    }
                    disabled={isSubmitting || disabled}
                />
            </div>
            {(!!errors[name] || !!helperText) && <FormHelperText error={!!errors[name]}>{errors[name] ?? helperText}</FormHelperText>}
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
}));

export type Props = {
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    defaultValue?: boolean,
    upperCase?: boolean,
    disabled?: boolean,
    required?:
        | boolean
        | {
              value: number,
              message: string,
          },
    minLength?:
        | number
        | {
              value: number,
              message: string,
          },
    maxLength?:
        | number
        | {
              value: number,
              message: string,
          },
    pattern?:
        | RegExp
        | {
              value: RegExp,
              message: string,
          },
    InputProps?: any,
    inputProps?: any,
    onChange?: any,
    idx?: number,
    classes?: any,
};
